import { create } from "zustand";

const useQueueStore = create((set) => ({
  currentQueues: [],
  addQueue: (videoDetails, index = -1) => {
    set((state) => {
      const currentQueues = state.currentQueues;
      if (index > -1) currentQueues.splice(index + 1, 0, videoDetails);
      return {
        currentQueues:
          index > -1
            ? [...currentQueues]
            : currentQueues.concat({ ...videoDetails }),
      };
    });
  },
  updateQueueStatus: (index, isPlayingStatus) => {
    set((state) => {
      const currentQueues = state.currentQueues;
      currentQueues[index] = {
        ...currentQueues[index],
        isPlayingNow: isPlayingStatus,
      };

      return {
        currentQueues: [...currentQueues],
      };
    });
  },
  clearQueue: () => {
    set({ currentQueues: [] });
  },
}));

export default useQueueStore;
